import { atom } from 'jotai';

type BrokeredOrderFileConfirmUploadParams = {
  fileId: string;
};

type BrokeredOrderFileConfirmUploadResult = {
  brokeredOrderFileConfirmUpload: {
    id: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    status: string;
  };
};

export const brokeredOrderFileConfirmUploadAtom = () =>
  atom(
    null,
    async (
      _get,
      _set,
      _params: BrokeredOrderFileConfirmUploadParams,
    ): Promise<BrokeredOrderFileConfirmUploadResult> => {
      throw new Error(
        'Not implemented: brokeredOrderFileConfirmUpload backend API pending',
      );
    },
  );
